import { render, staticRenderFns } from "./interview_msgl.vue?vue&type=template&id=497bb3b8&scoped=true&"
import script from "./interview_msgl.vue?vue&type=script&lang=js&"
export * from "./interview_msgl.vue?vue&type=script&lang=js&"
import style0 from "./interview_msgl.vue?vue&type=style&index=0&id=497bb3b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bb3b8",
  null
  
)

export default component.exports